<template>
    <div class="stats-container">

      <!-- <a href="http://www.msobcfdc.org/" class="link-anchor">
                                    Click here to go back on <span class="link">www.msobcfdc.org</span>
                                    </a> -->
        <div class="stats-main-wrap">
          <h3 style=" text-align: center; color:rgb(0, 0, 0); margin-bottom:12px;font-weight:bolder">DASHBOARD</h3>
          
            
          <div class="row stat-box-row no-gutters">
            
            <!-- <div class="col">
              <div class="stat-box-wrap">
                

                <div class="info-box1">
                  <h6 class="info-text">Total Registrations</h6>
                  <h5 class="number">{{loanData.totalProfile}}</h5>
                  
                </div> 
              </div> 
            </div>  -->


            <div class="col">
              <div class="stat-box-wrap">
                

                <div class="info-box2">
                  <h4 class="info-text">Total Applications</h4>
                  <!-- <h3 class="number">200</h3> -->
                  <h3 class="number">{{loanData.totalApp}}</h3>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->


            <div class="col">
              <div class="stat-box-wrap">
                

                <div class="info-box3">
                  <h4 class="info-text">Total LOI Generated</h4>
                  <!-- <h3 class="number">200</h3> -->
                  <h3 class="number">{{loanData.totalLoi}}</h3>
                  
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->


            <div class="col">
              <div class="stat-box-wrap">
               

                <div class="info-box4">
                  <h4 class="info-text">Total LOI Amount</h4>
                  <h3 class="number">{{loanData.totalAmt}} Cr.</h3>
                  <!-- <h3 class="number">200 .</h3> -->
                </div> <!-- info-box ends -->
              </div> <!-- stat-box-wrap -->
            </div> <!-- col -->
            
          </div> <!-- row -->
        </div> <!-- stat-main-wrap -->


        <!-- =========================== -->
     

        
    </div> <!-- stats-container -->
</template>

<script>
import apis from "@/apis";
export default {
  data() {
    return {
     
        loanData:{
          totalProfile:0,
          indApp:0,
          groupApp:0,
          EducationLoan:0
      }
    };
  },
  methods: {
    login() {
      this.$router.push("/login");
    },
    signup(typ){
        this.$router.push("/signup/"+typ);
    },
    signupWorker(){
      this.$router.push("/profile")
    },
    signupemployer(){
      this.$router.push("/LoginProfile");
    },
    signupagency(){
        this.$router.push("/toliprofile");
    },
    getAppData() {
      let promise = apis.getAppData();
      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.loanData = response.body;
            this.loanData.totalApp = parseInt(this.loanData.indApp) + parseInt(this.loanData.groupApp);
            this.loanData.totalLoi = parseInt(this.loanData.personalLoi) + parseInt(this.loanData.groupLoi);
            this.loanData.totalAmt = parseFloat(this.loanData.personalLoiAmt.replace(' Cr.','')) + parseFloat(this.loanData.groupLoiAmt.replace(' Cr.', ''));
            //console.log('loanData ' +loanData);
          }
        })
        .catch(err => {
          console.log("Error");
        });
    },
    getValues() {
      let promise = apis.getDashbord(this.newBoard);
      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.form = response.body[0];
          }
        })
        .catch(err => {
          console.log("Error");
        });
    },
    getValuesReg() {
      let promise = apis.getDashbord(this.regBoard);
      promise
        .then(response => {
          //console.log(response);
          if (response.status == 200) {
            this.formReg = response.body[0];
          }
        })
        .catch(err => {
          console.log("Error");
        });
    }
  },
  mounted() {
      this.getAppData();
    // this.getValues();
    // this.getValuesReg();
  }
};
</script>

<style scoped>
.container{
    width:100% !important;
}


/* UI changes by Akshay 15-08-2019 */

.link-anchor{
  font-size: 13px;
  font-weight: bold;
  color:#fff;
  background-color: #ab7806;
  padding:8px 20px;
  display: block;
  width: fit-content;
  border-radius: 4px;
}

.stats-main-wrap{
  margin-bottom:15px;
  padding: 10px;
}

.stats-heading{
  font-size: 17px;
  color:#000;
  font-weight: bold;
  margin-bottom:4px;
  text-align: center;
}

.row-2{
  margin-top:30px;
}

img.header-icon{
  width: 50px;
  margin:auto;
  display: block;
  margin-bottom:8px;
}

.stats-main-wrap .stat-box-wrap{
  display: flex;
  margin-top:10px;
  margin-bottom:10px;
  justify-content: space-around;
}
.stats-main-wrap .icon-box{
  background-color:#00bcd4;

  padding:8px;
  padding-top:12px;
  padding-bottom:12px;
  border:1px solid transparent;
  border-right: none;
  border-radius: 3px;
  border-top-right-radius: 0;
  border-bottom-right-radius: 0;
}

.stats-main-wrap .icon-box img{
  width: 40px;
  vertical-align: middle;
}

.stat-box-wrap .info-box1{
  border:1px solid #d3d3d3;
  background-color:#f1f1f1;
  border-radius: 15px;
  text-align: left;
  padding:10px;
  font-weight: bold;
  width: 350px;
  height: 140px;
}
.stat-box-wrap .info-box2{
  border:1px solid #d3d3d3;
  background-color:#fbcd92d1;
  border-radius: 15px;
  text-align: left;
  padding:10px;
  font-weight: bold;
  width: 350px;
  height: 140px;
}
.stat-box-wrap .info-box3{
  border:1px solid #d3d3d3;
  background-color:#c5ebca;
  border-radius: 15px;
  text-align: left;
  padding:10px;
  font-weight: bold;
  width: 350px;
  height: 140px;
}
.stat-box-wrap .info-box4{
  border:1px solid #d3d3d3;
  background-color:#fff9af;
  border-radius: 15px;
  text-align: left;
  padding:10px;
  font-weight: bold;
  width: 350px;
  height: 140px;
}

.stat-box-wrap .info-box1 h4{
  margin-bottom: 8px;
  margin-top: 5px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
}
.stat-box-wrap .info-box2 h4{
  margin-bottom: 8px;
  margin-top: 5px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
}
.stat-box-wrap .info-box3 h4{
  margin-bottom: 8px;
  margin-top: 5px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
}
.stat-box-wrap .info-box4 h4{
  margin-bottom: 8px;
  margin-top: 5px;
  font-size: 24px;
  font-weight: bold;
  color: #000;
  text-align: center;
}
.stat-box-wrap .info-box1 h3{
  font-size: 45px;
  font-weight: bold;
  color: #000;
  text-align: center;

}
.stat-box-wrap .info-box2 h3{
  font-size: 45px;
    font-weight: bold;
    color: #000;
    text-align: center;
}
.stat-box-wrap .info-box3 h3{
  font-size: 45px;
    font-weight: bold;
    color: #000;
    text-align: center;
}
.stat-box-wrap .info-box4 h3{
  font-size: 45px;
  font-weight: bold;
  color: #000;
  text-align: center;
}


@media(max-width: 1325px){
 
  .stats-boxes-2 .stat-box-wrap .info-box1{
  width:135px;
  margin-right: 5px;
}
.stats-boxes-2 .stat-box-wrap .info-box2{
  width:135px;
  margin-right: 5px;
}
.stats-boxes-2 .stat-box-wrap .info-box3{
  width:135px;
  margin-right: 5px;
}
.stats-boxes-2 .stat-box-wrap .info-box4{
  width:135px;
  margin-right: 5px;
}

}
@media(max-width: 1199px){
  .link-anchor{
    margin-bottom:17px;
  }
}


@media(max-width: 991px){
  .link-anchor{
    width: fit-content;
    margin:auto;
    margin-top:20px;
    margin-bottom:30px;
  }

  .stat-box-wrap .info-box1{
    width:150px;
  }
  .stat-box-wrap .info-box2{
    width:150px;
  }
  .stat-box-wrap .info-box3{
    width:150px;
  }
  .stat-box-wrap .info-box4{
    width:150px;
  }

  .stats-heading{
    margin-bottom:15px;
  }

   .stat-box-wrap{
    width:fit-content;
    margin-left:auto;
    margin-right:auto;
  }
}

@media(max-width:767PX){
  .stats-main-wrap .stat-box-wrap{
    padding-left:5px;
    padding-right:5px;
  }

   .stats-heading{
    font-size: 15px;
  }
}

@media(max-width:419px){
  .link-anchor{
    width:70%;
    text-align:center;
    font-size:12px;
  }
  }


</style>



// WEBPACK FOOTER //
// src/components/Portal/StatComponent2.vue